import { tryReportError } from '@ui/lib/bugsnag';
import { TFunction } from 'next-i18next';

import { extractErrorMessage } from './extractContractError';

/**
 * leverup contract error revert patterns
 * - CONTRACT_NAME: [MESSAGE]
 * - MESSAGE
 *
 * Common chain error patterns
 * - 'insufficient funds for gas + value. balance: ##### fee:0, value: #######'
 * - ...
 *
 * It is impractical to map all messages, this mapping is added on as-needed basis
 */
const getProperErrorMessage = (t: TFunction, rawMessage: string) => {
  switch (rawMessage) {
    case 'TradingCheckerFacet: This price will open a position immediately':
      return t('common.Trigger price too close to market price');
    case 'TradingCheckerFacet: Unable to trading at a price acceptable to the user':
      return t('common.Increase your slippage setting and try again');
    case 'VaultFacet: collateral oracle price too old':
    case 'LibPriceFacade: collateral oracle price too old':
      return t('common.Price updating, please try again shortly');
    case 'AnyCollateralConfigFacet: oracle disabled':
      return t('common.Collateral is temporarily unavailable');
    case 'TradingCheckerFacet: This token is not supported as reserve':
      return t('common.Collateral is not supported');
    case 'ExceedMaxTakeProfitAfterMarginRemoval':
      return t('common.Removing this amount would exceed the max TP cap');
    default:
      if (rawMessage.match(/insufficient funds for gas \+ value\./)?.[0]) {
        return t(
          'common.You do not have enough gas fund, try lower your native token input',
        );
      }

      return rawMessage;
  }
};

export const handleMutationError = (
  err: any,
  onMessage: (msg: string | undefined) => void,
  t: TFunction,
) => {
  const msg =
    err?.cause?.reason ??
    err?.cause?.data?.errorName ??
    (err instanceof Error ? extractErrorMessage(err.toString()) : undefined);
  if (!msg) {
    onMessage(undefined);
    tryReportError(new Error('Cannot extract message', { cause: err }));

    return;
  }

  const mappedMsg = getProperErrorMessage(t, msg);

  if (mappedMsg) {
    onMessage(mappedMsg);
  } else {
    // cannot id the error, report to bugsnag
    onMessage(undefined);
    tryReportError(new Error('Cannot extract message', { cause: err }));
  }
};
